import React from "react";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";

const Counter = ({
  end,
  duration,
  prefix = "",
  suffix = "",
  decimals = 0,
  separator = ".",
}) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Animation nur einmal auslösen
    threshold: 0.5, // Startet, wenn 50% des Elements sichtbar sind
  });

  return (
    <div ref={ref}>
      {inView ? (
        <CountUp
          end={end}
          duration={duration}
          prefix={prefix}
          suffix={suffix}
          decimals={decimals}
          decimal=","
          separator={separator}
        />
      ) : (
        "0"
      )}
    </div>
  );
};

export default Counter;
